module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filePreview"
  }, [_c('div', {
    staticClass: "previewPrint"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "m-b-20"
  }, [_vm._v("Please double check all text and spelling for possible errors. If anything looks incorrect, click on \"Back To Designer\" to go back and correct before proceeding. Otherwise, please check and approve each file below:")]), _vm._v(" "), _c('table', {
    staticClass: "table m-0"
  }, [_c('tbody', _vm._l((_vm.fileList), function(file) {
    return (_vm.hasFile(file)) ? _c('tr', {
      on: {
        "mouseover": function($event) {
          _vm.setPreview(file)
        }
      }
    }, [_c('td', [_c('h5', {
      staticClass: "m-b-5"
    }, [_vm._v(_vm._s(file.replace(/_/g, ' ').replace(/v/g, 'V').replace(/\b\w/g, function (l) { return l.toUpperCase(); })))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.description[file]))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_c('transition-group', {
      attrs: {
        "enter-active-class": "animated fadeInRight",
        "leave-active-class": "animated fadeOut"
      }
    }, [(_vm.approved.includes(file)) ? _c('i', {
      key: "1",
      staticClass: "icon-checkmark-circle pull-right m-t-10"
    }) : _vm._e(), _vm._v(" "), (_vm.pending.includes(file)) ? _c('button', {
      key: "2",
      staticClass: "btn btn-warning pull-right m-t-10",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.approve(file)
        }
      }
    }, [_vm._v("\n                                " + _vm._s((_vm.pending.includes(file)) ? 'Approve' : 'Approved') + "\n                            ")]) : _vm._e()])], 1)]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "enter-active-class": "animated fadeInDown"
    }
  }, [(_vm.pending.length === 0 && _vm.approved.length > 0) ? _c('hr', {
    key: "1",
    staticClass: "m-t-0"
  }) : _vm._e(), _vm._v(" "), (_vm.pending.length === 0 && _vm.approved.length > 0) ? _c('button', {
    key: "2",
    staticClass: "btn btn-success pull-right",
    on: {
      "mouseover": function($event) {
        _vm.setPreview('front')
      },
      "click": function($event) {
        _vm.checkProceed()
      }
    }
  }, [_vm._v("Continue to Product Selection")]) : _vm._e()])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("The file previews displayed to the left are how your files will be sent to print.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c7a96d18","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/FileApproval.vue
// module id = 334
// module chunks = 0